var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.438721,
    y: 0.677643,
    width: 45.2331,
    height: 44.9781,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_31_116",
    transform: "matrix(0.0104167 0 0 0.0104757 0 -0.00283558)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_31_116",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAACtUlEQVR4nO2avYoVMRiGH+0tLLTwp1MLvQpRwwjLLmKlhbWVteUiCFaiICh4F4K1wuoViOANLNr4By66in4yMKLIyXA2kzn5ex/4uskk+z6ZZHJmQQghhBBCCCGEEEIIIYTIElMxloEEkHaSSAAS0PQyNTup/0DLvCSARgW0hklAWiQgMRKQGAlIjAQkJjsBKiTAMpgIegKQgOSz0PQEpA/CtASlD8Na2gNawyQgLRKQGAlIjAQkRgISIwGJkYDESEBiihSw17aW8WlWApAAPQFoCUJLkPYAtAmjTbg5zFMPgFfAl6HeAI+BC3N33BoWUFvAqbk6bg0LrI/A2Tk6bg2bUJ+B07E7bg2bWFuxO26JLtJb17mQzlf5+4lFqtjhfx3paxe4CRwGDgE3gB3PtY9CBtCygG6J8NcXtLvuuf51yCBaFdAFht9zAPjpeSPaMy0KcEuEvzHS/iDwa0G7DyGDaU1AN2Hm/6HfE7QEJQp/fbhuUfuHIYOac53NibnDt9ATcQsCuhWE/zx0cLULcBM33J6LwLeRe/Sb78nQAdYsoFvBzO/vf37KIGsV4FYw8/t7rE0daI0CXCnh1yjAlRR+bQJcaeHXJMCVGH4tAlyp4dcgwJUcfukCXOnhlyzA1RB+qQJcLeGXKMDVFD4jgyixdksLnwxCs5bDJ4PgrOXwySA8azl8MgjQWg6fDEK0lsPPnXcKPx3HPOH/iPQZsf9cKUbY8IT3YqyRlp143PIIuDvSRmt+RJ56BFzxXK/wI/PWI+DEgmsVfmSOeMJ/D+wb/gnqKnAPeAl814YblzVPoDuDhGXPCnrbCWQz0kFNh6xAnij8tGxPEKBlZyJHA4P/BDwbvpiJCVxeIuyPw4n4PnANOAPsn9Kp+Mud/8LeHvaEzeHnieP/XCtm4PYg4dKwHBXFbx3vPTReRLO1AAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.1b6962b232b3e7da83cd83626a85a06b.svg";
export { ForwardRef as ReactComponent };